import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { setAccessToken } from '../services/api';
import Loading from '../components/Loading';
import { useLocation, Navigate } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

const AppLayout = ({ children }: Props) => {
  const { isLoading, user, isAuthenticated, getAccessTokenSilently, logout } =
    useAuth0();
  const location = useLocation();
  const currentPath = location.pathname;
  const [accessToken, setNewAccessToken] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated && user) {
      (async () => {
        try {
          const access_token = await getAccessTokenSilently();
          setNewAccessToken(access_token);
        } catch (error) {
          logout();
          console.log(error);
        }
      })();
    }
  }, [isAuthenticated, user, getAccessTokenSilently]);

  if (
    currentPath === '/signup' ||
    currentPath === '/login' ||
    currentPath === '/registerasset' ||
    currentPath === '/registerasset-success' ||
    currentPath === '/waiting'
  ) {
    return <>{children}</>;
  }

  if (!isAuthenticated) {
    logout();
    return <Navigate to="/login" />;
  }

  if (isLoading) {
    return <Loading heading="Loading" text="Please wait..." />;
  }

  if (accessToken) setAccessToken(accessToken);

  return <>{children}</>;
};

export default AppLayout;
